const shack = {
  state: {
    isshake: false
  },
  mutations: {
  }
}

export default shack
